import { render, staticRenderFns } from "./question-difficulty-select.vue?vue&type=template&id=527a2ae2"
import script from "./question-difficulty-select.vue?vue&type=script&lang=js"
export * from "./question-difficulty-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports